package com.trevorwiebe.timesheet.core.data

import com.trevorwiebe.timesheet.core.domain.TSResult
import kotlinx.coroutines.TimeoutCancellationException
import kotlinx.coroutines.withTimeout
import kotlin.time.Duration.Companion.milliseconds

object Utils {
    suspend fun errorWrapper(action: suspend () -> TSResult): TSResult {
        return try {
            withTimeout(15000.milliseconds) {
                action()
            }
        } catch (e: TimeoutCancellationException) {
            return TSResult(error = "Request timed out, please try again later")
        } catch (e: Exception) {
            e.printStackTrace()
            TSResult(error = e.message ?: e.toString())
        }
    }
}